import { render } from "./ButtonForms.vue?vue&type=template&id=2ed24781&scoped=true"
import script from "./ButtonForms.vue?vue&type=script&lang=js"
export * from "./ButtonForms.vue?vue&type=script&lang=js"

import "./ButtonForms.vue?vue&type=style&index=0&id=2ed24781&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed24781"]])

export default __exports__